export default __webpack_public_path__ + "static/media/BodyGame_03.ee613794.png";